import { ChangeDetectionStrategy, Component, HostBinding, OnInit, ViewChild, ViewContainerRef, computed, input } from '@angular/core';

import { EventParticipant } from '@frontend/sports/betting-offer/feature/model';
import { ShortNameModule } from '@frontend/sports/betting-offer/feature/short-team-names';
import { SitecorePopularBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { GridEvent } from '@frontend/sports/grid/core/feature/model';
import { ParticipantImageComponent } from '@frontend/sports/participant-image/feature';
import { isEmpty } from 'lodash-es';

import { EventNameMapperService } from '../../../event-details-common/event-name-mapper.service';
import { TimerModule } from '../../../timers/timer.module';

@Component({
    selector: 'ms-popular-bets-bet-builder-pod-header',
    imports: [TimerModule, ParticipantImageComponent],
    templateUrl: './popular-bets-bet-builder-pod-header.component.html',
    styleUrl: './popular-bets-bet-builder-pod-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopularBetsBetBuilderPodHeaderComponent implements OnInit {
    @ViewChild('badgeContainer', { read: ViewContainerRef }) container: ViewContainerRef;
    @HostBinding('class') className = 'popular-bets-bet-builder-pod-header';

    showBadge = input.required<boolean>();
    event = input.required<GridEvent>();
    showLogo = input.required<boolean>();
    titleColor = input<string | undefined>();
    logoSeparatorText: string;

    hasLogo = computed(
        () =>
            this.showLogo() &&
            this.event().participants.every((participant: EventParticipant) => {
                const hasLogo = !isEmpty(participant.image?.logo);
                const hasJersey = !isEmpty(participant.image?.jersey);
                return hasLogo || hasJersey;
            }),
    );

    constructor(
        public sitecorePopularBetsConfig: SitecorePopularBetsConfig,
        private eventNameMapper: EventNameMapperService,
    ) {
        this.logoSeparatorText = this.sitecorePopularBetsConfig.messages.LogoSeperator;
    }

    ngOnInit(): void {
        if (this.showBadge()) this.loadSGPBadgeComponent();
    }

    async loadSGPBadgeComponent(): Promise<void> {
        const { SGPBadgeComponent } = await import('../../../betbuilder/components/badge/sgp-badge/sgp-badge.component');
        this.container.clear();
        this.container.createComponent(SGPBadgeComponent);
    }

    get eventTitle(): string {
        return this.eventNameMapper.map(this.event(), false, ShortNameModule.PopularBets);
    }
}
